import { useMutation, useQuery } from '@apollo/client';
import { ComponentQueryLoader } from '../../../../../../../shared/component-query-loader';
import { CaseDetailsApplication } from './case-details-application';
import {
  Entity,
  SendReportCaseV1,
  SendReportCaseV1CaseDetailsApplicationInput,
  SendReportCaseV1RevisionRequest,
  SendReportV1CaseDetailsApplicationContainerEntitiesDocument,
  SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Document,
  SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateDocument
} from '../../../../../../../../generated';
import { message } from 'antd';

interface CaseDetailsApplicationContainerProps {
  caseId: string;
}
export const CaseDetailsApplicationContainer: React.FC<CaseDetailsApplicationContainerProps> = (props) => {
  const { data, loading, error } = useQuery(SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Document, {
    variables: {
      sendReportCaseV1Id: props.caseId
    }
  });

  const [updateSendReportCase] = useMutation(SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Document,
        variables: {
          sendReportCaseV1Id: props.caseId
        }
      }
    ]
  });

  const { data: entities, loading: entitiesLoading, error: entitiesError } = useQuery(SendReportV1CaseDetailsApplicationContainerEntitiesDocument);

  const onSave = async (values: SendReportCaseV1CaseDetailsApplicationInput) => {
    try {
      const updatedData = await updateSendReportCase({
        variables: {
          input: {
            id: props.caseId,
            caseDetails: {
              application: {
                destination: values.destination
              }
            }
          }
        }
      });

      if (updatedData.data?.sendReportCaseV1Update.status.success === false) {
        message.error('Failed to save Send Report case details');
      }

      if (updatedData.data?.sendReportCaseV1Update.status.success) {
        message.success('Send Report case details saved successfully');
      }
    } catch (error) {
      message.error(`Error Occurred while saving Send Report case details, ${error}`);
    }
  };

  const onSaveAndComplete = async (values: SendReportCaseV1CaseDetailsApplicationInput) => {
    try {
      const updatedData = await updateSendReportCase({
        variables: {
          input: {
            id: props.caseId,
            caseDetails: {
              application: {
                destination: values.destination
              }
            },
            revisionRequest: {
              requestedChanges: {
                requestUpdatedDestination: false,
              },
              revisionSubmittedAt: new Date().toISOString()
            }
          }
        }
      });

      if (!updatedData.data?.sendReportCaseV1Update.status.success) {
        message.error('Failed to save Send Report case details');
      }

      if (updatedData.data?.sendReportCaseV1Update.status.success) {
        message.success('Send Report case details saved successfully');
      }
    } catch (error) {
      message.error(`Error Occurred while saving Send Report case details, ${error}`);
    }
  };

  return (
    <ComponentQueryLoader
      error={error || entitiesError}
      loading={loading || entitiesLoading}
      hasData={data && entities}
      hasDataComponent={
        <CaseDetailsApplication
          data={data?.sendReportCaseV1 as SendReportCaseV1}
          entities={entities?.entities as Entity[]}
          revisionRequested={data?.sendReportCaseV1?.revisionRequest as SendReportCaseV1RevisionRequest}
          onSave={onSave}
          onSaveAndComplete={onSaveAndComplete}
        />
      }
    />
  );
};
